import skuDao from '../../../dao/skuDao';
import lookDao from '../../../dao/lookDao';
import {push} from 'react-router-redux';
import _orderBy from 'lodash/orderBy';

const RESET = 'pages/products/addoreditlook/RESET';
const LIST_ALL_SKUS = 'pages/products/addoreditlook/LIST_ALL_SKUS';
const LIST_ALL_SKUS_SUCCESS =
  'pages/products/addoreditlook/LIST_ALL_SKUS_SUCCESS';
const ADD_LOOK = 'pages/products/addoreditlook/ADD_LOOK';
const QUERY_LOOK = 'pages/products/addoreditlook/QUERY_LOOK';
const QUERY_LOOK_SUCCESS = 'pages/products/addoreditlook/QUERY_LOOK_SUCCESS';
const EDIT_LOOK = 'pages/products/addoreditlook/EDIT_LOOK';
const CREATE_LOOK = 'pages/products/addoreditlook/CREATE_LOOK';
const CREATE_LOOK_SUCCESS = 'pages/products/addoreditlook/CREATE_LOOK_SUCCESS';
const UPDATE_LOOK = 'pages/products/addoreditlook/UPDATE_LOOK';
const UPDATE_LOOK_SUCCESS = 'pages/products/addoreditlook/UPDATE_LOOK_SUCCESS';

const initialState = {
  skus: {},
  isLoaded: false,
  look: {},
};
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case RESET:
      return {...initialState};
    case LIST_ALL_SKUS:
      return {
        ...state,
      };
    case LIST_ALL_SKUS_SUCCESS:
      return {
        ...state,
        skus: action.skus,
      };
    case ADD_LOOK:
      return {
        ...state,
        isLoaded: true,
        look: action.look,
      };
    case EDIT_LOOK:
      return {
        ...state,
        isLoaded: true,
        look: action.look,
      };
    case CREATE_LOOK:
      return {
        ...state,
      };
    case CREATE_LOOK_SUCCESS:
      return {
        ...state,
      };
    case UPDATE_LOOK:
      return {
        ...state,
      };
    case UPDATE_LOOK_SUCCESS:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export function reset() {
  return {
    type: RESET,
  };
}

export function listAllSkus() {
  return async dispatch => {
    dispatch({
      type: LIST_ALL_SKUS,
    });
    let params = {
      pageIndex: 1,
      pageSize: 20,
    };
    const results = await skuDao.listAllSkus(params).then(json => json.results);
    let skus = {};
    results.forEach(r => {
      if (!skus[r.skuType]) skus[r.skuType] = [];
      skus[r.skuType].push(r);
    });
    Object.keys(skus).forEach(type => {
      skus[type] = _orderBy(skus[type], 'skuName', 'asc');
    });
    dispatch({
      skus,
      type: LIST_ALL_SKUS_SUCCESS,
    });
  };
}

export function addLook() {
  return {
    type: ADD_LOOK,
    look: lookDao.initLook(),
  };
}

export function queryLook(lookId) {
  return dispatch => {
    dispatch({
      type: QUERY_LOOK,
    });
    return lookDao.queryLook(lookId).then(json => {
      dispatch({
        type: QUERY_LOOK_SUCCESS,
      });
      return json;
    });
  };
}

export function editLook(look) {
  return {
    type: EDIT_LOOK,
    look,
  };
}

export function createLook(look) {
  return dispatch => {
    dispatch({
      type: CREATE_LOOK,
    });
    return lookDao.createLook(look).then(r => {
      dispatch({
        type: CREATE_LOOK_SUCCESS,
      });
      dispatch(push({pathname: '/products/list-looks'}));
      return r;
    });
  };
}

export function updateLook(look) {
  return dispatch => {
    dispatch({
      type: UPDATE_LOOK,
    });
    return lookDao.updateLook(look).then(r => {
      dispatch({
        type: UPDATE_LOOK_SUCCESS,
      });
      dispatch(push({pathname: '/products/list-looks'}));
      return r;
    });
  };
}
